import { Link } from "gatsby-theme-advanced";

export type { LinkProps } from "gatsby-theme-advanced";
export const BaseLink = Link;
